import { Input } from "@/components/ui/input";
import { FieldWrapper } from "@/forms/field-wrapper";
import { useFormContext } from "react-hook-form";
import { trans } from "@/service/i18n/i18n";
import { cn } from "@/lib/utils";

export function TextField({
  field,
  disabled = false,
  shouldRenderLabel = true,
  onChange = () => {},
  labelClassName = undefined,
  inputClassName,
}: FormField) {
  const { control } = useFormContext();

  return (
    <FieldWrapper
      field={field}
      control={control}
      disabled={disabled}
      shouldRenderLabel={shouldRenderLabel}
      labelClassName={labelClassName}
      renderComponent={(formField) => (
        <Input
          {...formField}
          onChange={(event) => {
            formField.onChange(event);
            onChange(event);
          }}
          placeholder={field.placeholder ? trans(field.placeholder) : undefined}
          name={field.name}
          id={field.name}
          className={cn("bg-white", inputClassName)}
          type={"text"}
        />
      )}
    />
  );
}
